import Controller from "csi/action/Controller";
import locale from "csi/locale";
import message from "csi/message";
import reflection from "csi/reflection";
import { setLocationRevisionUrl } from "csi/router";
import csiView from "csi/view";
import declare from "dojo/_base/declare";
import { C8RequestError } from "src/c8-platform/core/request";


const RefreshSizeRange = declare(Controller, {

	/**
	* @override
	* If there is no change in sizes, informs the user that nothing happened
	*/
	_onPublishError(err: Error): void {
		const c8error = err as C8RequestError;
		if (c8error.csiErrorCode?.includes("NO_CHANGE_IN_SIZES")) {
			this.postProcess();
			message.showInfo(locale.resource("NewRefreshRevision"));
		} else {
			this.inherited(arguments);
		}
	},


	/**
	* @override
	* Provides additional functionality for updating the current revision in the event that size changes.
	*/
	postProcessSuccess() {
    		const settingsNode = reflection.getObject("centric://REFLECTION/INSTANCE/ProductSpecAdmin/null");
    		const bNewRevision = settingsNode.SCGenNewSizeChartRevision;
		if (bNewRevision) {
			const sizeChartNode = this.m_response.getNodeOfType("SizeChart");
			const latestRevisionUrl = sizeChartNode.CurrentRevision;
			setLocationRevisionUrl(latestRevisionUrl);
		} else {
			this.widget.refreshData();
			const dimensionsView = csiView.getView("Dimensions");
			if (dimensionsView) {
				dimensionsView.refreshWidget();
			}
		}
	},
});

export = RefreshSizeRange;
